import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import UserService from '../services/UserService';
import './DealDetailPage.css';

// ADMIN page: set a new password for a user who forgot theirs.
function ResetPassword() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState('idle'); // idle | saving | done | error
  const [message, setMessage] = useState('');

  const save = (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setStatus('error');
      setMessage('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setStatus('error');
      setMessage('The two passwords are not the same.');
      return;
    }

    setStatus('saving');
    UserService.resetUserPassword(email.trim(), password)
      .then(() => {
        setStatus('done');
        setMessage(`Password updated for ${email.trim()}. They can log in with the new password now.`);
        setPassword('');
        setConfirm('');
      })
      .catch((err) => {
        const code = err.response && err.response.status;
        setStatus('error');
        if (code === 401 || code === 403) {
          setMessage('Only ADMIN accounts can change passwords. Log in with an admin account.');
        } else if (code === 404) {
          setMessage('No user found with that email.');
        } else if (code === 400) {
          setMessage('Password must be at least 8 characters.');
        } else {
          setMessage('Could not update the password. Please try again.');
        }
      });
  };

  return (
    <div className="detail-page">
      <div className="detail-layout page-narrow">
        <main>
          <nav className="detail-breadcrumb" aria-label="Breadcrumb">
            <Link to="/user/dashboard">Dashboard</Link>
            <span>›</span>
            <span>Reset Password</span>
          </nav>

          <section className="page-card">
            <h1>Reset a User's Password</h1>
            <p className="page-intro">For when someone forgets their password. Only ADMIN accounts can do this.</p>

            <form className="page-form" onSubmit={save}>
              <label>
                User's email
                <input type="email" placeholder="jiya@gmail.com" required
                  value={email} onChange={(e) => setEmail(e.target.value)} />
              </label>
              <label>
                New password (at least 8 characters)
                <input type="password" required autoComplete="new-password"
                  value={password} onChange={(e) => setPassword(e.target.value)} />
              </label>
              <label>
                Type the new password again
                <input type="password" required autoComplete="new-password"
                  value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              </label>

              {status === 'done' && <p className="page-success-line">{message}</p>}
              {status === 'error' && <p className="page-error">{message}</p>}

              <button type="submit" disabled={status === 'saving'}>
                {status === 'saving' ? 'Saving...' : 'Set New Password'}
              </button>
            </form>
          </section>
        </main>
      </div>
    </div>
  );
}

export default ResetPassword;
